module.exports = "<main class=\"quote-page\">\n    <iframe id=\"typeform-full\" width=\"100%\" height=\"100%\" frameborder=\"0\" src=\"https://richardfreyreyes.typeform.com/to/FH5BSO\"></iframe>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/quote/quote.component.html
// module id = ./src/app/components/quote/quote.component.html
// module chunks = main